import React, { useContext } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import context from '../context';
import RateBar from './ratebar';

const Header = styled.header`
  background:#0d4a42; position:relative; width:100%; z-index:1000;
`;
const Nav = styled.nav`
  align-items:center; display:flex; gap:22px; margin:0 auto; max-width:1440px; padding:14px 28px;
`;
const Brand = styled(Link)`
  align-items:center; background:#fff; border-radius:14px; display:flex; flex:0 0 auto; height:72px; justify-content:center; padding:9px 15px; width:190px;
  img { height:100%; max-width:100%; object-fit:contain; }
`;
const Publish = styled(Link)`
  background:#f4a71d; border-radius:999px; color:#3a2c00 !important; font:600 14px 'Poppins',sans-serif; padding:12px 20px; white-space:nowrap;
`;
const Menu = styled.div`
  align-items:center; display:flex; gap:clamp(16px,2.2vw,30px); margin-left:auto;
  a { border-bottom:2px solid transparent; color:#eaf3f0 !important; font:500 clamp(13px,1.1vw,15px) 'Poppins',sans-serif; padding:8px 0; white-space:nowrap; }
  a:hover { border-color:#f4a71d; color:#fff !important; }
`;

export default function DesktopHeader(){
  const state = useContext(context);
  return <Header className="d-none d-lg-block"><RateBar/><Nav><Brand to="/"><img src={state.logoDark || state.logo} alt="Las Flores Propiedades"/></Brand><Publish to="/publica">Publica tu propiedad</Publish><Menu><Link to="/">Inicio</Link><Link to="/properties">Propiedades</Link><Link to="/proyectos">Proyectos</Link><Link to="/about">Nosotros</Link><Link to="/contact">Contacto</Link></Menu></Nav></Header>;
}
